import CryptoJS from 'crypto-js';

const AES = CryptoJS.AES;
// const yek_otpyrc = "!q0RIHCM3ncrypTk";
// const iv = CryptoJS.enc.Utf8.parse(yek_otpyrc);
// const key = CryptoJS.enc.Utf8.parse(yek_otpyrc);
// const crypto_option = {
//   keySize: 128 / 8,
//   iv: iv,
//   mode: CryptoJS.mode.CBC,
//   padding: CryptoJS.pad.Pkcs7
// };

const crypto = () => {
  // const crypto_passkey = '^7%0&4J5*0*^%-#6';
  // const iv = CryptoJS.enc.Utf8.parse(crypto_passkey);
  // const key = CryptoJS.enc.Utf8.parse(crypto_passkey);
  // const new_passkey = AES.decrypt(axios.defaults.headers.common['authkey'], key, {
  //   keySize: 128 / 8,
  //   iv: iv,
  //   mode: CryptoJS.mode.CBC,
  //   padding: CryptoJS.pad.Pkcs7
  // }).toString(CryptoJS.enc.Utf8);

  const r0QiYek = global.config.r0QiYek;

  return {
    key: CryptoJS.enc.Utf8.parse(r0QiYek),
    option: {
      keySize: 128 / 8,
      iv: CryptoJS.enc.Utf8.parse(r0QiYek),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  };
}

export const AESEncrypt = (value) => {
  //var ret_value = AES.encrypt(value, key, crypto_option).toString();
  var ret_value = AES.encrypt(value, crypto().key, crypto().option).toString();
  return (ret_value)
}

export const AESDecrypt = (value) => {
  //var ret_value = AES.decrypt(value, key, crypto_option).toString(CryptoJS.enc.Utf8);
  var ret_value = AES.decrypt(value, crypto().key, crypto().option).toString(CryptoJS.enc.Utf8);
  return (ret_value)
}
